
import { Component, Vue } from 'vue-property-decorator'
import ItemModal from '../../modules/ItemModal.vue'
import CheckoutModal from '../../modules/order/CheckoutModal.vue'
import FooterLayout from '../homepage/Footer.vue'
import CreditsModule from '../../modules/credits/Index.vue'
import UserDropdown from '../../modules/user/UserDropdown.vue'
import Cart from '../../modules/Cart.vue'
import SearchHeader from '../../modules/headers/SearchHeader.vue'
import UserModule from '../../modules/headers/UserModule.vue'

@Component({
  components: {
    UserModule,
    SearchHeader,
    Cart,
    UserDropdown,
    FooterLayout,
    CheckoutModal,
    ItemModal,
    CreditsModule,
  },
})
export default class credits extends Vue {}
